<template>
  <div class="shadow p-3 mx-auto my-5 rounded-8 w-75 bg-white">
    <h2 class="p-3 text-primary">{{ $t('analysts.candidates.title') }}</h2>

    <div
      v-if="props.originalObjectsArray && props.originalObjectsArray.length === 0"
      class="p-3 text-primary mb-5"
    >
      {{ $t('analysts.candidates.noCandidates') }}
    </div>

    <div class="p-3" v-else>
      <div class="mb-4">
        <SearchBarV2
          :placeholder="`${$t('analysts.candidates.searchCandidate')}...`"
          :modelValue="props.currentSearch"
          @update:modelValue="$emit('search-change', $event)"
        />
      </div>

      <div
        v-if="originalObjectsArray && originalObjectsArray.length === 0"
        class="p-3 text-primary mb-5"
      >
        {{ $t('noSearchResults') }}
      </div>

      <div v-else>
        <ul class="row row-cols-1 row-cols-lg-2 ps-0 mb-5">
          <li
            class="col"
            v-for="candidate in originalObjectsArray"
            :key="candidate.id"
          >
            <div class="row row-cols-1 row-cols-lg-2 shadow-sm p-3 mx-1">
              <div class="col">
                <div>
                  {{ fullname(candidate) }}
                </div>
                <div>
                  <b>{{ candidate.email }}</b>
                </div>
              </div>
              <div class="col">
                <div>
                  <RouterLink
                    :to="`/analysts/candidate-requests/${candidate.id}`"
                    class="btn general-btn"
                    >{{ $t('analysts.candidates.seeCandidate') }}</RouterLink
                  >
                </div>
              </div>
            </div>
          </li>
        </ul>

        <div class="text-center">
          <VueAwesomePaginate
            :modelValue="props.currentPage"
            :total-items="props.totalCount"
            :items-per-page="nEntries"
            :max-pages-shown="8"
            @update:modelValue="$emit('page-change', $event)"
            :back-button-class="props.currentPage === 1 ? 'd-none' : 'back-button'"
            :next-button-class="props.currentPage === Math.ceil(props.totalCount / nEntries) ? 'd-none' : 'next-button'"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'
import SearchBarV2 from '@/components/SearchBarV2.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps({
  title: String,
  fromView: String,
  originalObjectsArray: Array,
  totalCount: Number,
  currentPage: {
    type: Number,
    required: true
  },
  currentSearch: String
})

const fullname = (candidate) => {
  const fullname = candidate.name
    ? `${candidate.name} ${candidate.lastname}`
    : t('analysts.requests.candidate')
  return fullname
}
/*
  Search and Pagination
*/

const nEntries = 8

</script>

<style lang="scss" scoped>
.general-btn {
  float: right;
}

ul {
  list-style-type: none;
}
</style>
